import { Toast } from 'mint-ui';
import { bus } from '../bus.js';
export default {
    backLogin: function(result) {
        if (result && result.data) {
            Toast({
                message: result.data,
                duration: 1000
            });
            setTimeout(() => {}, 1000);
        }
    }
};



// WEBPACK FOOTER //
// ./src/utils/common.js